<template>
  <div class="progressFrame">
    <div class="bar" :class="{ 'colored' : parseInt(step) >= 1 }" id="one"></div>
    <div class="bar" :class="{ 'colored' : parseInt(step) >= 2 }" id="two"></div>
    <div class="bar" :class="{ 'colored' : parseInt(step) >= 3 }" id="three"></div>
    <div class="bar" :class="{ 'colored' : parseInt(step) >= 4 }" id="four"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressStep',
  props: {
    step: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .progressFrame {
    display: flex;
  }
  .bar {
    height: 5px;
    width: 100%;
    background-color: var(--color-secondary-light);
    margin-right: 4px;
  }
  .bar:nth-child(1) {
    border-top-left-radius: 2.5px;
    border-bottom-left-radius: 2.5px;
  }
  .bar:nth-child(4) {
    margin-right: unset;
    border-top-right-radius: 2.5px;
    border-bottom-right-radius: 2.5px;
  }
  .colored {
    background-color: var(--color-secondary);
  }
</style>